import React from 'react';

import TextFilter from 'components/search_sidebar/sidebar_search';

import type { Filters } from './types';

type Slice = Pick<Filters, 'query'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function QueryFilter({ query, onChange }: Props) {
  return (
    <TextFilter
      additionalClasses="flex-fill me-2"
      placeholder="Search Activities"
      value={query}
      onChange={event => onChange({ query: event.target.value })}
    />
  );
}
